import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getHomePageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.HOMEPAGE, {
    method: METHODS.GET,
  });
  return data;
};
